import type React from "react";

import { colorsPalettes } from "@similarweb/styles";
import { PlainTooltip } from "@similarweb/ui-components";

import { translate } from "app/filters/i18nFilter";
import { CompanyLogo } from "app/pages/sales-intelligence/common-components/CompanyLogo/CompanyLogo";
import { OverflowTooltip } from "app/pages/sales-intelligence/common-components/OverflowTooltip/OverflowTooltip";
import type { Competitor } from "app/pages/sales-intelligence/modules/ai-agent/types/meeting";

import { StyledCompetitorsItem, StyledRemoveIconButton, StyledRemoveIconContainer } from "./styles";

type CoompetitorProps = {
    competitor: Competitor;
    onRemoveCompetitor: (domain: string) => void;
    disabled?: boolean;
};

export const CompetitorItem: React.FC<CoompetitorProps> = ({ competitor, disabled = false, onRemoveCompetitor }) => {
    return (
        <StyledCompetitorsItem>
            <CompanyLogo
                src={competitor.favicon || ""}
                disabled={disabled}
            />
            <OverflowTooltip
                text={competitor.companyName || ""}
                disabled={disabled}
                fontVariant="chip1TopRow"
                color={disabled ? colorsPalettes.midnight[100] : colorsPalettes.carbon[500]}
            />
            <PlainTooltip
                tooltipContent={translate("common.remove")}
                placement="top"
                enabled={!disabled}
            >
                <StyledRemoveIconContainer>
                    <StyledRemoveIconButton
                        iconName="delete"
                        iconColor={disabled ? colorsPalettes.midnight[100] : colorsPalettes.carbon[300]}
                        iconSize="xs"
                        type="flat"
                        onClick={() => onRemoveCompetitor(competitor.domain)}
                        disabled={disabled}
                    />
                </StyledRemoveIconContainer>
            </PlainTooltip>
        </StyledCompetitorsItem>
    );
};
